import { useSelector } from "react-redux";
import { useAppSelector } from "../../../src/store/hooks/StoreHooks"


import React, { useState, useRef } from "react";
import "./report.scss";
import PumpChart from "../calculation-section/pump/composite-pump-plot/composite-curves";
import FlowRangeChart from "../calculation-section/pump/composite-pump-plot/performmance-curves";
import { RootState } from "../../store/ConfigureStore";
import ScatterLineChart from "../calculation-section/cable/cable-clearance/ScatterLineChart";
interface IEquipmentDetails {
  ReportData?: any;
}

const EquipmentDetails: React.FC<IEquipmentDetails> = (ReportData: any) => {
  const getCompositeGraphData = useSelector(
    (state: RootState) => state?.pump?.CompositeCurveData
  );
  const targetFlowRateForPump = useSelector(
    (state: RootState) => state.gasCalculations.GasFinalCalculatedData
  );

  const {
    cableClearance, motorChart, tubingCableChart,
    pumpMotorLeadChart,
    sealMotorLeadChart
  } = useAppSelector((state) => state?.cable)
  const { tab1Input } = useAppSelector((state) => state?.tubing)
  const PumpInputData = useSelector((state: RootState) => state.pump.PumpInput);
  const PumpInputDataCalculated = useSelector(
    (state: RootState) => state.pump.PumpInputCalculated
  );
  const GasCalculationOutput = useSelector(
    (state: RootState) => state.gasCalculations.GasCalculationOutPut
  );
  const numberOfGasSeparator = useSelector(
    (state: RootState) => state.gasCalculations?.BasicGasCalculation?.noOfGasSeps
  )
  const { BasicGasCalculation } = useAppSelector(((state: RootState) => state.gasCalculations));
  const {
    GKXCalculationData,
    CP1CalculationData,
    CP2CalculationData,
    CP3CalculationData,
  } = useAppSelector((state) => state?.gasHandler);

  const FinalGasCalculationOutput = useSelector(
    (state: RootState) => state.gasCalculations.GasFinalCalculatedData
  );
  const selectedPumpData = useSelector(
    (state: RootState) => state?.pump?.SelectedPump
  );
  const ChargePumpListSelected = useSelector(
    (state: RootState) => state.gasCalculations.chargePumpName
  )
  const ChargePumpList2Selected = useSelector(
    (state: RootState) => state.gasCalculations.chargePump2Name
  )
  const ChargePumpList3Selected = useSelector(
    (state: RootState) => state.gasCalculations.chargePump3Name
  )
  const ChargePumpGKXListSelected = useSelector(
    (state: RootState) => state.gasHandler.gasHandlerPumpName
  )
  const cp1Calculations = useSelector(
    (state: RootState) => state.gasHandler.CP1CalculationData
  )
  const cp2Calculations = useSelector(
    (state: RootState) => state.gasHandler.CP2CalculationData
  )
  const cp3Calculations = useSelector(
    (state: RootState) => state.gasHandler.CP3CalculationData
  )
  const gasData = useSelector(
    (state: RootState) => state.gasCalculations.BasicGasCalculation
  );
  const gkxCalculations = useSelector(
    (state: RootState) => state.gasHandler.GKXCalculationData
  )
  const [compositePumpPlotDetails, setCompositePumpPlotDetails] = useState({
    compositePumpPlotHandlerFactors: {
      flow: "100",
      head: "100",
      power: "100",
    },
  });

  const CompPumpInputCalculated = useSelector(
    (state: RootState) => state.pump.CompPumpInputCalculated
  );

  const totalPower = GKXCalculationData?.totalPower ||
    CP1CalculationData?.totalPower ||
    CP2CalculationData?.totalPower ||
    CP3CalculationData?.totalPower ||
    PumpInputDataCalculated?.hPOPPump;

  const actNamePump = PumpInputData?.actNamePump_HP3500;
  const headValue = compositePumpPlotDetails?.compositePumpPlotHandlerFactors?.head ||
    CompPumpInputCalculated?.compositeHeadCorrectionFactor;

  const powerValue = compositePumpPlotDetails?.compositePumpPlotHandlerFactors?.power ||
    CompPumpInputCalculated?.compositePowerCorrectionFactor;

  const flowValue = compositePumpPlotDetails?.compositePumpPlotHandlerFactors?.flow ||
    CompPumpInputCalculated?.compositeFlowCorrectionFactor;

  const compositeChartRef = useRef<HTMLDivElement | null>(null);
  const chart1Config = {
    seriesDefaults: {
      type: "scatterLine" as const,
      style: "smooth" as const,
      markers: {
        visible: false,
      },
      width: 1.0,
    },
    legend: {
      position: "bottom",
      labels: {
        font: "8px Segoe UI",
        color: "#fff",
      },
    },
    series: [
      {
        name: "Casing",
        data: tubingCableChart?.[0],
        color: "white",
      },
      {
        name: "Tubing",
        data: tubingCableChart?.[1],
        color: "blue",
      },
      {
        name: "Cable",
        data: tubingCableChart?.[2],
        color: "red",
      },
    ],
  };


  const chart2Config = {
    seriesDefaults: {
      type: "scatterLine" as const,
      style: "smooth" as const,
      markers: {
        visible: false,
      },
      width: 1.0,
    },
    legend: {
      position: "bottom",
      labels: {
        font: "8px Segoe UI",
        color: "#fff",
      },
    },
    series: [
      {
        name: "Casing",
        data: pumpMotorLeadChart?.[0],
        color: "white",
      },
      {
        name: "Pump",
        data: pumpMotorLeadChart?.[3],
        color: "blue",
      },
      {
        name: "MotorLead",
        data: pumpMotorLeadChart?.[4],
        color: "red",
      },
    ],
  };

  const chart3Config = {
    seriesDefaults: {
      type: "scatterLine" as const,
      style: "smooth" as const,
      markers: {
        visible: false,
      },
      width: 1.0,
    },
    legend: {
      position: "bottom",
      labels: {
        font: "8px Segoe UI",
        color: "#fff",
      },
    },
    series: [
      {
        name: "Casing",
        data: sealMotorLeadChart?.[0],
        color: "white",
      },
      {
        name: "Protector",
        data: sealMotorLeadChart?.[5],
        color: "blue",
      },
      {
        name: "MotorLead",
        data: sealMotorLeadChart?.[6],
        color: "red",
      },
    ],
  };

  const chart4Config = {
    seriesDefaults: {
      type: "scatterLine" as const,
      style: "smooth" as const,
      markers: {
        visible: false,
      },
      width: 1.0,
    },
    legend: {
      position: "bottom",
      labels: {
        font: "9px Segoe UI",
        color: "#fff",
      },
    },
    series: [
      {
        name: "Casing",
        data: motorChart?.[0],
        color: "white",
      },
      {
        name: "Motor",
        data: motorChart?.[7],
        color: "blue",
      },
    ],
    count: 2,
  };


  return (
    <>
      <div className="determine-widget-containers">
        <div className="header-main border-b-[1px] border-darkcolor-400">
          <div className="flex flex-row justify-between">
            <div>
              <p className="text-[18px] font-semibold text-neutral-25">DETERMINE equipment details</p>
              <p className="text-[14px] font-medium text-neutral-200">
                Specific details of the ESP design's key components, along with surface equipment details
              </p>
            </div>
          </div>
        </div>
        <div className="text-[14px] font-semibold text-neutral-25 py-[20px] px-[24px]">Summary</div>
        <div className="">
          <div className="w-full md:w-2/3 grid grid-cols-4 gap-4 pl-[24px] rounded-lg shadow text-[12px]">
            <div className="text-[12px] font-semibold border-[1px] border-[#E3E8EF] rounded-[4px] shadow text-center px-[8px] py-[2px]"> Total power : {totalPower} {actNamePump}</div>
            <div className="text-[12px] font-semibold border-[1px] border-[#E3E8EF] rounded-[4px] shadow text-center px-[8px] py-[2px]"> Flow correction : {`${flowValue ? `${flowValue} %` : ''}`}</div>
            <div className="text-[12px] font-semibold border-[1px] border-[#E3E8EF] rounded-[4px] shadow text-center px-[8px] py-[2px]"> Head correction : {`${headValue ? `${headValue} %` : ''}`}</div>
            <div className="text-[12px] font-semibold border-[1px] border-[#E3E8EF] rounded-[4px] shadow text-center px-[8px] py-[2px]"> Power correction : {`${powerValue ? `${powerValue} %` : ''}`}</div>
          </div>
          <div className="mt-6 space-y-4 pb-8">
            <table className="w-full">
              <tr>
                <td className='font-bold px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>Pump name</td>
                <td className='font-bold px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>No.of stage</td>
                <td className='font-bold px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>Lift contribution</td>
                <td className='font-bold px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>Power contribution</td>
                <td className='font-bold px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>Intake flow </td>
                <td className='font-bold px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>GVF intake</td>
              </tr>
              <tr>
                <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] font-normal p-4'>
                  {selectedPumpData?.pumpName}
                </td>
                <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] font-normal p-4'>
                  {PumpInputData?.pump_DesrdStges}
                </td>
                <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] font-normal p-4'>
                  {PumpInputDataCalculated?.pmpFinalTDH}
                  <span className="ml-1">{PumpInputData.actNamePump_RequiredTDH}</span>
                </td>
                <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] font-normal p-4'>
                  {PumpInputDataCalculated?.hPOPPump}
                  <span className="ml-1">{PumpInputData?.actNamePump_HP3500}</span>
                </td>
                <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] font-normal p-4'>
                  {targetFlowRateForPump?.preTFV}{" "}
                  <span className="ml-1">{BasicGasCalculation?.actNameGas_TotalFluidVolume}</span>
                </td>
                <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] font-normal p-4'>
                  {targetFlowRateForPump?.FreeGasGvf}{" "}
                  {BasicGasCalculation?.actNameGas_FreeGas}
                </td>
              </tr>
              {ChargePumpList3Selected && (
                <tr>
                  <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] font-normal p-4'>{ChargePumpList3Selected}</td>
                  <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] font-normal p-4'>{gasData?.chargePumpDesrdStge3}</td>
                  <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] font-normal p-4'>{cp3Calculations?.finalTDH} {PumpInputData?.actNamePump_RequiredTDH}</td>
                  <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] font-normal p-4'>{GasCalculationOutput?.CP3_HPRating} {PumpInputData?.actNamePump_HP3500}</td>
                  <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] font-normal p-4'>{cp3Calculations?.targetFlowRate} <span className="ml-1">{BasicGasCalculation?.actNameGas_TotalFluidVolume}</span></td>
                  <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] font-normal p-4'>
                    {
                      ChargePumpList2Selected ? GasCalculationOutput?.CP2_FreeGas :
                        ChargePumpListSelected ? GasCalculationOutput?.CP1_FreeGas :
                          ChargePumpGKXListSelected ? GasCalculationOutput?.GKX_FreeGas :
                            Number(numberOfGasSeparator) === 4 ? GasCalculationOutput?.SP4_FreeGas :
                              Number(numberOfGasSeparator) === 3 ? GasCalculationOutput?.SP3_FreeGas :
                                Number(numberOfGasSeparator) === 2 ? GasCalculationOutput?.SP2_FreeGas :
                                  Number(numberOfGasSeparator) === 1 ? GasCalculationOutput?.SP1_FreeGas :
                                    GasCalculationOutput?.Intake_FreeGas}
                    <span className="ml-1">{BasicGasCalculation?.actNameGas_FreeGas}</span>
                  </td>
                </tr>
              )}
              {ChargePumpList2Selected && (
                <tr>
                  <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] font-normal p-4'>{ChargePumpList2Selected}</td>
                  <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] font-normal p-4'>{gasData?.chargePumpDesrdStge2}</td>
                  <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] font-normal p-4'>{cp2Calculations?.finalTDH} {PumpInputData?.actNamePump_RequiredTDH}</td>
                  <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] font-normal p-4'>{GasCalculationOutput?.CP2_HPRating} {PumpInputData?.actNamePump_HP3500}</td>
                  <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] font-normal p-4'>{cp2Calculations?.targetFlowRate} <span className="ml-1">{BasicGasCalculation?.actNameGas_TotalFluidVolume}</span></td>
                  <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] font-normal p-4'>
                    {ChargePumpListSelected ? GasCalculationOutput?.CP1_FreeGas :
                      ChargePumpGKXListSelected ? GasCalculationOutput?.GKX_FreeGas :
                        Number(numberOfGasSeparator) === 4 ? GasCalculationOutput?.SP4_FreeGas :
                          Number(numberOfGasSeparator) === 3 ? GasCalculationOutput?.SP3_FreeGas :
                            Number(numberOfGasSeparator) === 2 ? GasCalculationOutput?.SP2_FreeGas :
                              Number(numberOfGasSeparator) === 1 ? GasCalculationOutput?.SP1_FreeGas :
                                GasCalculationOutput?.Intake_FreeGas}
                    <span className="ml-1">{BasicGasCalculation?.actNameGas_FreeGas}</span>
                  </td>
                </tr>
              )}
              {ChargePumpListSelected && (
                <tr>
                  <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] font-normal p-4'>{ChargePumpListSelected}</td>
                  <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] font-normal p-4'>{gasData?.chargePumpDesrdStge}</td>
                  <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] font-normal p-4'>{cp1Calculations?.finalTDH} {PumpInputData?.actNamePump_RequiredTDH}</td>
                  <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] font-normal p-4'>{GasCalculationOutput?.CP1_HPRating} {PumpInputData?.actNamePump_HP3500}</td>
                  <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] font-normal p-4'>{cp1Calculations?.targetFlowRate}<span className="ml-1">{BasicGasCalculation?.actNameGas_TotalFluidVolume}</span></td>
                  <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] font-normal p-4'>
                    {
                      ChargePumpGKXListSelected ? GasCalculationOutput?.GKX_FreeGas :
                        Number(numberOfGasSeparator) === 4 ? GasCalculationOutput?.SP4_FreeGas :
                          Number(numberOfGasSeparator) === 3 ? GasCalculationOutput?.SP3_FreeGas :
                            Number(numberOfGasSeparator) === 2 ? GasCalculationOutput?.SP2_FreeGas :
                              Number(numberOfGasSeparator) === 1 ? GasCalculationOutput?.SP1_FreeGas :
                                GasCalculationOutput?.Intake_FreeGas}
                    <span className="ml-1">{BasicGasCalculation?.actNameGas_FreeGas}</span>
                  </td>
                </tr>
              )}
              {ChargePumpGKXListSelected && (
                <tr>
                  <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] font-normal p-4'>{ChargePumpGKXListSelected}</td>
                  <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] font-normal p-4'>{gkxCalculations?.desiredStages}</td>
                  <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] font-normal p-4'>{gkxCalculations?.finalTDH} {PumpInputData?.actNamePump_RequiredTDH}</td>
                  <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] font-normal p-4'>{GasCalculationOutput?.GKX_HPRating} {gasData?.actNameGas_ChargePumpHP}</td>
                  <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] font-normal p-4'>{gkxCalculations?.targetFlowRate} <span className="ml-1">{BasicGasCalculation?.actNameGas_TotalFluidVolume}</span></td>
                  <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] font-normal p-4'>
                    {Number(numberOfGasSeparator) === 4 ? GasCalculationOutput?.SP4_FreeGas :
                      Number(numberOfGasSeparator) === 3 ? GasCalculationOutput?.SP3_FreeGas :
                        Number(numberOfGasSeparator) === 2 ? GasCalculationOutput?.SP2_FreeGas :
                          Number(numberOfGasSeparator) === 1 ? GasCalculationOutput?.SP1_FreeGas :
                            GasCalculationOutput?.Intake_FreeGas}
                    <span className="ml-1">{BasicGasCalculation?.actNameGas_FreeGas}</span>
                  </td>
                </tr>
              )}
            </table>
            {/* </div> */}
          </div>
          <div className='mb-[15px] px-[200px]' ref={compositeChartRef}>
            <div className='pl-8 w-full'>
              <PumpChart data={getCompositeGraphData} />
            </div>
            <div className='flex justify-between items-start p-4 gap-4 w-full'>
              <FlowRangeChart data={getCompositeGraphData} />
            </div>
          </div>
        </div>
      </div>
      <div className="determine-widget-containers">
        <div className="header-main">
          <div className="flex flex-row justify-between">
            <div>
              <p className="text-[18px] font-semibold text-neutral-25">DETERMINE equipment details</p>
              <p className="text-[14px] font-medium text-neutral-200">
                Specific details of the ESP design's key components, along with
                surface equipment details.
              </p>
            </div>
          </div>
        </div>
        <div className="container-body flex flex-col gap-4 border-t border-dark">
          <div className="flex flex-col gap-5">
            <div className="card-container">
              <div className="card wd100 bg-dark">
                <p className="px-4 pt-4 pb-2 text-[14px] font-semibold text-neutral-25">Casing</p>
                <ul>
                  <li>
                    <span>Outer diameter</span>
                    <span>{ReportData?.ReportData?.CasingOD} {ReportData?.ReportData?.CasingOD_Unit}</span>
                  </li>
                  <li>
                    <span>Inner diameter</span>
                    <span>{ReportData?.ReportData?.CasingID} {ReportData?.ReportData?.CasingOD_Unit}</span>
                  </li>
                  <li>
                    <span>Weight</span>
                    <span>{ReportData?.ReportData?.CasingWeight} {ReportData?.ReportData?.CasingWeight_Unit}</span>
                  </li>
                  <li>
                    <span>Drift ID</span>
                    <span>{ReportData?.ReportData?.Casing_Drift_ID + ' in'}</span>
                  </li>
                </ul>
              </div>

              <div className="card wd100 bg-dark">
                <p className="px-4 pt-4 pb-2 text-[14px] font-semibold text-neutral-25">Tubing</p>
                <ul>
                  <li>
                    <span>Outer diameter</span>
                    <span>{ReportData?.ReportData?.TubingOD} {ReportData?.ReportData?.TubingOD_Unit}</span>
                  </li>
                  <li>
                    <span>Inner diameter</span>
                    <span>{ReportData?.ReportData?.TubingID} {ReportData?.ReportData?.TubingOD_Unit}</span>
                  </li>
                  <li>
                    <span>Weight</span>
                    <span>{ReportData?.ReportData?.TubingWeight} {ReportData?.ReportData?.TubingWeight_Unit}</span>
                  </li>
                  <li>
                    <span>Type</span>
                    <span>{ReportData?.ReportData?.TubingType}</span>
                  </li>
                </ul>
              </div>

              <div className="card wd100 bg-dark">
                <p className="px-4 pt-4 pb-2 text-[14px] font-semibold text-neutral-25">Liner</p>
                <ul>
                  <li>
                    <span>Outer diameter</span>
                    <span>{ReportData?.ReportData?.LinerOD} {ReportData?.ReportData?.LinerOD_Unit}</span>
                  </li>
                  <li>
                    <span>Inner diameter</span>
                    <span>{ReportData?.ReportData?.LinerID} {ReportData?.ReportData?.LinerID_Unit}</span>
                  </li>
                  <li>
                    <span>Weight</span>
                    <span>{ReportData?.ReportData?.LinerWeight} {ReportData?.ReportData?.LinerWeight_Unit}</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="flex flex-col gap-[16px] w-full">
              <div className="section section-mb">
                <p className="pt-4 pl-4 text-[14px] font-semibold text-neutral-25">Gas separator / BOI</p>
                <div className="ReportGrid">
                  <div className="grid-item">
                    <span>Model No.</span>
                    <span>{ReportData?.ReportData?.Gas_GasSeparator}</span>
                  </div>
                  <div className="grid-item">
                    <span>Number of separators</span>
                    <span>{ReportData?.ReportData?.GasSep_NoOfSeparator}</span>
                  </div>
                  <div className="grid-item">
                    <span>Free gas at intake</span>
                    <span>{ReportData?.ReportData?.FreeGasIntakePercent + ' %'}</span>
                  </div>
                  <div className="grid-item">
                    <span>Free gas at discharge</span>
                    <span>{ReportData?.ReportData?.GasSep_FreeGasDischarge + ' %'}</span>
                  </div>
                  <div className="grid-item">
                    <span>Intake volume</span>
                    <span>{ReportData?.ReportData?.TotalVolumeIntake + ' bpd'}</span>
                  </div>
                  <div className="grid-item">
                    <span>Discharge volume</span>
                    <span>{ReportData?.ReportData?.GasSep_TFVDischarge + ' bpd'}</span>
                  </div>
                  <div className="grid-item">
                    <span>Pressure at intake</span>
                    <span>{ReportData?.ReportData?.GasSep_PressureIntake + ' psi'}</span>
                  </div>
                  <div className="grid-item">
                    <span>Pressure at discharge</span>
                    <span>{ReportData?.ReportData?.GasBOIPressureDischarge + ' psi'}</span>
                  </div>
                </div>
              </div>
              {ReportData?.ReportData?.IsGKXVisible && <div className="section section-mb bg-dark">
                <p className="pt-4 pl-4 text-[14px] font-semibold text-neutral-25">Gas handler</p>
                <div className="ReportGrid">
                  <div className="grid-item">
                    <span>Model No.</span>
                    <span>{ReportData?.ReportData?.GKX}</span>
                  </div>
                  <div className="grid-item">
                    <span>No of stages</span>
                    <span>{ReportData?.ReportData?.GKXNoOfStage}</span>
                  </div>

                  <div className="grid-item">
                    <span> Intake volume</span>
                    <span>{ReportData?.ReportData?.GKX_TFVIntake + ' bpd'} </span>
                  </div>
                  <div className="grid-item">
                    <span>Discharge volume</span>
                    <span>{ReportData?.ReportData?.GKX_TFVDischarge + ' bpd'}</span>
                  </div>

                  <div className="grid-item">
                    <span>Pressure at intake</span>
                    <span>{ReportData?.ReportData?.GKX_PressureIntake + ' psi'}</span>
                  </div>
                  <div className="grid-item">
                    <span>Pressure at discharge</span>
                    <span>{ReportData?.ReportData?.GKX_PressureDischarge + ' psi'}</span>
                  </div>

                  <div className="grid-item">
                    <span>Free gas at intake</span>
                    <span>{ReportData?.ReportData?.GKX_FreeGasIntake + ' %'}</span>
                  </div>
                  <div className="grid-item">
                    <span>Free gas at discharge</span>
                    <span>{ReportData?.ReportData?.GKX_FreeGasDischarge + ' %'}</span>
                  </div>

                  <div className="grid-item">
                    <span>Lift / Stage</span>
                    <span>{ReportData?.ReportData?.GKXLiftStage + ' ft'}</span>
                  </div>
                  <div className="grid-item">
                    <span>BHP gas handler only</span>
                    <span>{ReportData?.ReportData?.BHPGasHandlerOnly + ' hp'}</span>
                  </div>

                  <div className="grid-item">
                    <span>Efficiency</span>
                    <span>{ReportData?.ReportData?.GKXEfficiency + ' %'} </span>
                  </div>

                  <div className="grid-item">
                    <span>Total power</span>
                    <span>{ReportData?.ReportData?.GKXTotalPower + ' hp'} </span>
                  </div>
                  <div className="grid-item">
                    <span>Type of shaft</span>
                    <span>{ReportData?.ReportData?.GKXShaftType}</span>
                  </div>

                  <div className="grid-item">
                    <span>TDH</span>
                    <span>{ReportData?.ReportData?.GKXFinalTDH + ' ft'}</span>
                  </div>

                  <div className="grid-item">
                    <span>Shaft loading</span>
                    <span>{ReportData?.ReportData?.GKXShaftLoading + ' %'}</span>
                  </div>
                </div>
              </div>}
              {ReportData?.ReportData?.IsGasChargePumpsVisible && <div className="section section-mb bg-dark">
                <p className="pt-4 pl-4 text-[14px] font-semibold text-neutral-25">Charge pump 1</p>
                <div className="ReportGrid">
                  <div className="grid-item">
                    <span>Charge pump 1</span>
                    <span>{ReportData?.ReportData?.Gas_ChargePump1}</span>
                  </div>
                  <div className="grid-item">
                    <span>No of stages</span>
                    <span>{ReportData?.ReportData?.Gas_ChargePump1_Stages}</span>
                  </div>

                  <div className="grid-item">
                    <span> Intake volume</span>
                    <span>{ReportData?.ReportData?.ChargPmp1_TFVIntake + ' bpd'}</span>
                  </div>
                  <div className="grid-item">
                    <span>Discharge volume</span>
                    <span>{ReportData?.ReportData?.ChargPmp1_TFVDischarge + ' bpd'}</span>
                  </div>

                  <div className="grid-item">
                    <span>Pressure at intake</span>
                    <span>{ReportData?.ReportData?.ChargPmp1_PressureIntake + ' psi'}</span>
                  </div>
                  <div className="grid-item">
                    <span>Pressure at discharge</span>
                    <span>{ReportData?.ReportData?.ChargPmp1_PressureDischarge + ' psi'}</span>
                  </div>

                  <div className="grid-item">
                    <span>Free gas at intake</span>
                    <span>{ReportData?.ReportData?.ChargPmp1_FreeGasIntake + ' %'}</span>
                  </div>
                  <div className="grid-item">
                    <span>Free gas at discharge</span>
                    <span>{ReportData?.ReportData?.ChargPmp1_FreeGasDischarge + ' %'}</span>
                  </div>

                  <div className="grid-item">
                    <span>Lift / Stage</span>
                    <span>{ReportData?.ReportData?.ChgPum1LiftStage + ' ft'}</span>
                  </div>
                  <div className="grid-item">
                    <span>BHP charge pump 1 only</span>
                    <span>{ReportData?.ReportData?.BHPChargPmp1Only + ' %'}</span>
                  </div>

                  <div className="grid-item">
                    <span>Efficiency</span>
                    <span>{ReportData?.ReportData?.ChgPum1Efficiency + ' %'}</span>
                  </div>

                  <div className="grid-item">
                    <span>Total power</span>
                    <span>{ReportData?.ReportData?.ChgPum1TotalPower + ' hp'}</span>
                  </div>
                  <div className="grid-item">
                    <span>Type of shaft</span>
                    <span>{ReportData?.ReportData?.ChgPum1ShaftType}</span>
                  </div>

                  <div className="grid-item">
                    <span>TDH</span>
                    <span>{ReportData?.ReportData?.ChgPum1FinalTDH + ' ft'}</span>
                  </div>

                  <div className="grid-item">
                    <span>Shaft loading</span>
                    <span>{ReportData?.ReportData?.ChargPm1ShaftLoading + ' %'}</span>
                  </div>
                </div>
              </div>}
              {ReportData?.ReportData?.IsGasChargePumps2Visible && <div className="section section-mb bg-dark">
                <p className="pt-4 pl-4 text-[14px] font-semibold text-neutral-25">Charge pump 2</p>
                <div className="ReportGrid">
                  <div className="grid-item">
                    <span>Charge pump 2</span>
                    <span>{ReportData?.ReportData?.Gas_ChargePump2}</span>
                  </div>
                  <div className="grid-item">
                    <span>No of stages</span>
                    <span>{ReportData?.ReportData?.Gas_ChargePump2_Stages}</span>
                  </div>

                  <div className="grid-item">
                    <span> Intake volume</span>
                    <span>{ReportData?.ReportData?.ChargPmp2_TFVIntake + ' bpd'}</span>
                  </div>
                  <div className="grid-item">
                    <span>Discharge volume</span>
                    <span>{ReportData?.ReportData?.ChargPmp2_TFVDischarge + ' bpd'}</span>
                  </div>

                  <div className="grid-item">
                    <span>Pressure at intake</span>
                    <span>{ReportData?.ReportData?.ChargPmp2_PressureIntake + ' psi'}</span>
                  </div>
                  <div className="grid-item">
                    <span>Pressure at discharge</span>
                    <span>{ReportData?.ReportData?.ChargPmp2_PressureDischarge + ' psi'}</span>
                  </div>

                  <div className="grid-item">
                    <span>Free gas at intake</span>
                    <span>{ReportData?.ReportData?.ChargPmp2_FreeGasIntake + ' %'}</span>
                  </div>
                  <div className="grid-item">
                    <span>Free gas at discharge</span>
                    <span>{ReportData?.ReportData?.ChargPmp2_FreeGasDischarge + ' %'}</span>
                  </div>

                  <div className="grid-item">
                    <span>Lift / Stage</span>
                    <span>{ReportData?.ReportData?.ChgPum2LiftStage + ' ft'}</span>
                  </div>
                  <div className="grid-item">
                    <span>BHP charge pump 2 only</span>
                    <span>{ReportData?.ReportData?.BHPChargPmp2Only + ' %'}</span>
                  </div>

                  <div className="grid-item">
                    <span>Efficiency</span>
                    <span>{ReportData?.ReportData?.ChgPum2Efficiency + ' %'}</span>
                  </div>

                  <div className="grid-item">
                    <span>Total power</span>
                    <span>{ReportData?.ReportData?.ChgPum2TotalPower + ' hp'}</span>
                  </div>
                  <div className="grid-item">
                    <span>Type of shaft</span>
                    <span>{ReportData?.ReportData?.ChgPum2ShaftType}</span>
                  </div>

                  <div className="grid-item">
                    <span>TDH</span>
                    <span>{ReportData?.ReportData?.ChgPum2FinalTDH + ' ft'}</span>
                  </div>

                  <div className="grid-item">
                    <span>Shaft loading</span>
                    <span>{ReportData?.ReportData?.ChargPmp2ShaftLoading + ' %'}</span>
                  </div>
                </div>
              </div>}
              {ReportData?.ReportData?.IsGasChargePumps3Visible && <div className="section section-mb bg-dark">
                <p className="pt-4 pl-4 text-[14px] font-semibold text-neutral-25">Charge pump 3</p>
                <div className="ReportGrid">
                  <div className="grid-item">
                    <span>Charge pump 3</span>
                    <span>{ReportData?.ReportData?.Gas_ChargePump3}</span>
                  </div>
                  <div className="grid-item">
                    <span>No of stages</span>
                    <span>{ReportData?.ReportData?.Gas_ChargePump3_Stages}</span>
                  </div>

                  <div className="grid-item">
                    <span> Intake volume</span>
                    <span>{ReportData?.ReportData?.ChargPmp3_TFVIntake + ' bpd'}</span>
                  </div>
                  <div className="grid-item">
                    <span>Discharge volume</span>
                    <span>{ReportData?.ReportData?.ChargPmp3_TFVDischarge + ' bpd'}</span>
                  </div>

                  <div className="grid-item">
                    <span>Pressure at intake</span>
                    <span>{ReportData?.ReportData?.ChargPmp3_PressureIntake + ' psi'}</span>
                  </div>
                  <div className="grid-item">
                    <span>Pressure at discharge</span>
                    <span>{ReportData?.ReportData?.ChargPmp3_PressureDischarge + ' psi'}</span>
                  </div>

                  <div className="grid-item">
                    <span>Free gas at intake</span>
                    <span>{ReportData?.ReportData?.FC_FreeGasIntake + ' %'}</span>
                  </div>
                  <div className="grid-item">
                    <span>Free gas at discharge</span>
                    <span>{ReportData?.ReportData?.FC_FreeGasDischarge + ' %'}</span>
                  </div>

                  <div className="grid-item">
                    <span>Lift / Stage</span>
                    <span>{ReportData?.ReportData?.ChgPum3LiftStage + ' ft'}</span>
                  </div>
                  <div className="grid-item">
                    <span>BHP charge pump 3 Only</span>
                    <span>{ReportData?.ReportData?.BHPChargPmp3Only + ' %'}</span>
                  </div>

                  <div className="grid-item">
                    <span>Efficiency</span>
                    <span>{ReportData?.ReportData?.ChgPum3Efficiency + ' %'}</span>
                  </div>

                  <div className="grid-item">
                    <span>Total power</span>
                    <span>{ReportData?.ReportData?.ChgPum3TotalPower + ' hp'}</span>
                  </div>
                  <div className="grid-item">
                    <span>Type of shaft</span>
                    <span>{ReportData?.ReportData?.ChgPum3ShaftType}</span>
                  </div>

                  <div className="grid-item">
                    <span>TDH</span>
                    <span>{ReportData?.ReportData?.ChgPum3FinalTDH + ' ft'}</span>
                  </div>
                  
                  <div className="grid-item">
                    <span>Shaft loading</span>
                    <span>{ReportData?.ReportData?.ChargPmp3ShaftLoading + ' %'}</span>
                  </div>
                </div>
              </div>}
              <div className="section section-mb bg-dark">
                <p className="pt-4 pl-4 text-[14px] font-semibold text-neutral-25">Main pump</p>
                <div className="ReportGrid">
                  <div className="grid-item">
                    <span>Model number</span>
                    <span>{ReportData?.ReportData?.Pump}</span>
                  </div>
                  <div className="grid-item">
                    <span>No of stages</span>
                    <span>{ReportData?.ReportData?.PumpNoOfStages}</span>
                  </div>

                  <div className="grid-item">
                    <span>Surface desired production</span>
                    <span>{ReportData?.ReportData?.Pump_DesiredFlowRate + ' bpd'}</span>
                  </div>
                  <div className="grid-item">
                    <span>Free gas at discharge</span>
                    <span>{ReportData?.ReportData?.Pump_FreeGasDischarge + ' %'}</span>
                  </div>

                  <div className="grid-item">
                    <span>Free gas at intake</span>
                    <span>{ReportData?.ReportData?.Pump_FreeGasIntake + ' %'}</span>
                  </div>
                  <div className="grid-item">
                    <span>Discharge volume</span>
                    <span>{ReportData?.ReportData?.Pump_TFVDischarge + ' bpd'}</span>
                  </div>

                  <div className="grid-item">
                    <span>Intake volume</span>
                    <span>{ReportData?.ReportData?.Pump_TFVIntake + ' bpd'}</span>
                  </div>
                  <div className="grid-item">
                    <span>Pressure at discharge</span>
                    <span>{ReportData?.ReportData?.Pump_PressureDischarge + ' psi'}</span>
                  </div>

                  <div className="grid-item">
                    <span>Pressure at intake</span>
                    <span>{ReportData?.ReportData?.Pump_IntakePressure + ' psi'}</span>
                  </div>
                  <div className="grid-item">
                    <span>Shaft load</span>
                    <span>{ReportData?.ReportData?.Pump_PercentShaftLoad + ' %'}</span>
                  </div>

                  <div className="grid-item">
                    <span>Housing type</span>
                    <span>{ReportData?.ReportData?.Pump_HousingPressure}</span>
                  </div>

                  <div className="grid-item">
                    <span>Type of pump shaft</span>
                    <span>{ReportData?.ReportData?.Pump_ShaftType}</span>
                  </div>
                </div>
              </div>
              <div className="section section-mb bg-dark">
                <p className="pt-4 pl-4 text-[14px] font-semibold text-neutral-25">Protector</p>
                <div className="ReportGrid">
                  <div className="grid-item">
                    <span>Lower tandem</span>
                    <span>{ReportData?.ReportData?.LowerProtector}</span>
                  </div>
                  <div className="grid-item">
                    <span>Upper tandem</span>
                    <span>{ReportData?.ReportData?.UpperProtector}</span>
                  </div>

                  <div className="grid-item">
                    <span>Bearing load %</span>
                    <span>{ReportData?.ReportData?.Protector_BearingLoad + ' %'}</span>
                  </div>
                  <div className="grid-item">
                    <span>Shaft load %</span>
                    <span>{ReportData?.ReportData?.Protector_ShaftLoad + ' %'}</span>
                  </div>
                  <div className="grid-item">
                    <span>Bearing type</span>
                    <span>{ReportData?.ReportData?.BearingType}</span>
                  </div>
                  <div className="grid-item">
                    <span>Shaft type</span>
                    <span> {ReportData?.ReportData?.ShaftType}</span>
                  </div>
                </div>
              </div>
              <div className="section section-mb bg-dark">
                <p className="pt-4 pl-4 text-[14px] font-semibold text-neutral-25">Oil contraction</p>
                <div className="ReportGrid">
                  <div className="grid-item">
                    <span>Lower tandem chamber #1 operation</span>
                    <span>{ReportData?.ReportData?.Protector_LT_Operation_1 + ' %'}</span>
                  </div>
                  <div className="grid-item">
                    <span>Lower tandem chamber #1 pull</span>
                    <span>{ReportData?.ReportData?.Protector_LT_Pull_1 + ' %'}</span>
                  </div>

                  <div className="grid-item">
                    <span>Lower tandem chamber #2 operation</span>
                    <span>{ReportData?.ReportData?.Protector_LT_Operation_2 + ' %'}</span>
                  </div>
                  <div className="grid-item">
                    <span>Lower tandem chamber #2 pull</span>
                    <span>{ReportData?.ReportData?.Protector_LT_Pull_2 + ' %'}</span>
                  </div>

                  <div className="grid-item">
                    <span>Lower tandem chamber #3 operation</span>
                    <span>{ReportData?.ReportData?.Protector_LT_Operation_3 + ' %'}</span>
                  </div>
                  <div className="grid-item">
                    <span>Lower tandem chamber #3 pull</span>
                    <span>{ReportData?.ReportData?.Protector_UT_Pull_3 + ' %'}</span>
                  </div>

                  <div className="grid-item">
                    <span>Upper tandem chamber #1 operation</span>
                    <span>{ReportData?.ReportData?.Protector_UT_Operation_1 + ' %'}</span>
                  </div>
                  <div className="grid-item">
                    <span>Upper tandem chamber #1 pull</span>
                    <span>{ReportData?.ReportData?.Protector_UT_Pull_1 + ' %'}</span>
                  </div>

                  <div className="grid-item">
                    <span>Upper tandem chamber #2 operation</span>
                    <span>{ReportData?.ReportData?.Protector_UT_Operation_2 + ' %'}</span>
                  </div>
                  <div className="grid-item">
                    <span>Upper tandem chamber #2 pull</span>
                    <span>{ReportData?.ReportData?.Protector_UT_Pull_2 + ' %'}</span>
                  </div>

                  <div className="grid-item">
                    <span>Upper tandem chamber #3 operation</span>
                    <span>{ReportData?.ReportData?.Protector_LT_Operation_3 + ' %'}</span>
                  </div>

                  <div className="grid-item">
                    <span>Upper tandem chamber #3 pull</span>
                    <span>{ReportData?.ReportData?.Protector_UT_Pull_3 + ' %'}</span>
                  </div>
                </div>
              </div>
              <div className="section section-mb bg-dark">
                <p className="pt-4 pl-4 text-[14px] font-semibold text-neutral-25">Motor rating {ReportData?.ReportData?.MotorDeratingPercent + '%'}
                  </p>
                <div className="ReportGrid">
                  <div className="grid-item">
                    <span>Model number</span>
                    <span>{ReportData?.ReportData?.Motor}</span>
                  </div>
                  <div className="grid-item">
                    <span>Total power demand</span>
                    <span>{ReportData?.ReportData?.Motor_PowerRequired + ' hp'}</span>
                  </div>
                  <div className="grid-item">
                    <span>Motor OD</span>
                    <span>{ReportData?.ReportData?.Motor_OD + ' in'}</span>
                  </div>
                  <div className="grid-item">
                    <span>Name plate power</span>
                    <span>{ReportData?.ReportData?.Motor_NamePlatePower} {ReportData?.ReportData?.Motor_NamePlatePower_Unit}</span>
                  </div>
                  <div className="grid-item">
                    <span>Name plate voltage</span>
                    <span>{ReportData?.ReportData?.Motor_NamePlateVoltage} {ReportData?.ReportData?.Motor_NamePlateVoltageUnit}</span>
                  </div>
                  <div className="grid-item">
                    <span>Name plate current</span>
                    <span>{ReportData?.ReportData?.Motor_NamePlateCurrent} {ReportData?.ReportData?.Motor_NamePlateCurrentUnit}</span>
                  </div>
                  <div className="grid-item">
                    <span>Operating efficiency</span>
                    <span>{ReportData?.ReportData?.Motor_OperatingEfficiency}</span>
                  </div>
                  <div className="grid-item">
                    <span>Motor load % @ 52 Hz</span>
                    <span>{ReportData?.ReportData?.Motor_LoadAt60Hz + ' %'}</span>
                  </div>
                  <div className="grid-item">
                    <span>Operating current</span>
                    <span>{ReportData?.ReportData?.Motor_OperatingCurrent + ' A'}</span>
                  </div>
                  <div className="grid-item">
                    <span>Operating voltage</span>
                    <span>{ReportData?.ReportData?.Motor_OperatingVoltage + ' V'}</span>
                  </div>
                  <div className="grid-item">
                    <span>Operating temperature</span>
                    <span>{ReportData?.ReportData?.Motor_OperatingTemperature}{" "}{ReportData?.ReportData?.Motor_OperatingTemperatureUnit}</span>
                  </div>
                  <div className="grid-item">
                    <span>Operating power factor</span>
                    <span>{ReportData?.ReportData?.Motor_OperatingPowerFactor} </span>
                  </div>
                  <div className="grid-item">
                    <span>Operating power</span>
                    <span>{ReportData?.ReportData?.Motor_OperatingPower} {ReportData?.ReportData?.Motor_OperatingPowerUnit}</span>
                  </div>
                  <div className="grid-item">
                    <span>Fluid velocity past motor</span>
                    <span>{ReportData?.ReportData?.Motor_Velocity} {ReportData?.ReportData?.Motor_VelocityUnit}</span>
                  </div>
                  <div className="grid-item">
                    <span>Operating speed</span>
                    <span>{ReportData?.ReportData?.Motor_OperatingSpeed} RPM</span>
                  </div>
                  <div className="grid-item">
                    <span>kW @ {ReportData?.ReportData?.OperatingFrequency} Hz</span>
                    <span>{ReportData?.ReportData?.MotorKW} kW</span>
                  </div>
                  <div className="grid-item">
                    <span>Sensor</span>
                    <span>{ReportData?.ReportData?.Motor_Sensor}</span>
                  </div>
                </div>
              </div>
              <div className="section section-mb bg-dark">
                <p className="pt-4 pl-4 text-[14px] font-semibold text-neutral-25">Cable</p>
                <div className="ReportGrid">
                  <div className="grid-item">
                    <span>Downhole cable length</span>
                    <span>{ReportData?.ReportData?.BottomOfEspSensor}</span>
                  </div>
                  <div className="grid-item">
                    <span>Surface cable length</span>
                    <span>{ReportData?.ReportData?.SurfaceCableLength}{" "}{ReportData?.ReportData?.SurfaceCableLength_Unit}</span>
                  </div>

                  <div className="grid-item">
                    <span>Cable selected</span>
                    <span>{ReportData?.ReportData?.Cable}</span>
                  </div>
                  <div className="grid-item">
                    <span>Total cable length</span>
                    <span>{ReportData?.ReportData?.Cable_EstCableLength}{" "}{ReportData?.ReportData?.Cable_EstCableLength_Unit}</span>
                  </div>

                  <div className="grid-item">
                    <span>Total cable volt loss</span>
                    <span>{ReportData?.ReportData?.Cable_VoltageLoss + ' V'}</span>
                  </div>
                  <div className="grid-item">
                    <span>Surface voltage @{ReportData?.ReportData?.OperatingFrequency} Hz</span>
                    <span>{ReportData?.ReportData?.Surface_SurfaceVoltage + ' '}{ReportData?.ReportData?.Surface_SurfaceVoltage_Unit}</span>
                  </div>

                  <div className="grid-item">
                    <span>Cable volt loss/1000 ft</span>
                    <span>{ReportData?.ReportData?.CablVoltLoss1000 + ' V'}</span>
                  </div>
                  <div className="grid-item">
                    <span>Max conductor temperature</span>
                    <span>{ReportData?.ReportData?.CableMaxConductorTemp + ' °F'}</span>
                  </div>

                  <div className="grid-item">
                    <span>% V.Drop / Nm Plate motor volt</span>
                    <span>{ReportData?.ReportData?.CableVDrop + ' %'}</span>
                  </div>
                  <div className="grid-item">
                    <span>Ampacity</span>
                    <span>{ReportData?.ReportData?.CableAmpacity + ' A'}</span>
                  </div>

                  <div className="grid-item">
                    <span>Conductor temperature @{ReportData?.ReportData?.OperatingFrequency} Hz</span>
                    <span>{ReportData?.ReportData?.CableConductorTempDesign + " °F"}</span>
                  </div>
                </div>
              </div>
              <div className="header-main-2">
                <p className="pl-4 text-[14px] font-semibold text-neutral-25">Cable clearance check</p>
                <div className="grid grid-cols-4 gap-4 p-4 text-white">
                  <div className="bg-[#1E293B] p-4 rounded-lg border border-darkcolor-400">
                    <h3 className="text-md font-bold mb-2 border-b  border-white pb-2">
                      Casing-Tubing-Cable
                    </h3>
                    <ScatterLineChart {...chart1Config} />
                    <p className="text-sm text-gray-400 mt-2">
                      Clearance: <span className="text-white">{cableClearance?.ClrnceForTubng} {tab1Input?.actNameCable_ClearanceTubing}</span>
                    </p>
                    <p className="text-sm mt-2">
                      {cableClearance?.MsgsForTubng}
                    </p>
                  </div>
                  <div className="bg-[#1E293B] p-4 rounded-lg border border-darkcolor-400">
                    <h3 className="text-md font-bold mb-2 border-b border-white pb-2">
                      Casing-Pump-Motor lead
                    </h3>
                    <ScatterLineChart {...chart2Config} />

                    <p className="text-sm text-gray-400 mt-2">
                      Clearance: <span className="text-white">{cableClearance?.ClrnceForPmp} {tab1Input?.actNameCable_ClearancePump}</span>
                    </p>
                    <p className="text-sm mt-2"> {cableClearance?.MsgsForPmp}</p>
                  </div>
                  <div className="bg-[#1E293B] p-4 rounded-lg border border-darkcolor-400">
                    <h3 className="text-md font-bold mb-2 border-b  border-white pb-2">
                      Casing-Seal-Motor lead
                    </h3>
                    <ScatterLineChart {...chart3Config} />

                    <p className="text-sm text-gray-400 mt-2">
                      Clearance: <span className="text-white">{cableClearance?.ClrnceForPrtctr} {tab1Input?.actNameCable_ClearanceProtector}</span>
                    </p>
                    <p className="text-sm mt-2">
                      {cableClearance?.MsgsForProtctr}
                    </p>
                  </div>
                  <div className="bg-[#1E293B] p-4 rounded-lg border border-darkcolor-400">
                    <h3 className="text-md font-bold mb-2 border-b  border-white pb-2">
                      Casing-Motor
                    </h3>
                    <ScatterLineChart {...chart4Config} />

                    <p className="text-sm text-gray-400 mt-2">
                      Clearance: <span className="text-white">{cableClearance?.ClrnceForMotr} {tab1Input?.actNameCable_ClearanceMotor}</span>
                    </p>
                    <p className="text-sm mt-2">
                      {cableClearance?.MsgsForMotr}
                    </p>
                  </div>
                </div>
              </div>
              <div className="section section-mb bg-dark">
                <p className="pt-4 pl-4 text-[14px] font-semibold text-neutral-25">Surface equipment</p>
                <div className="ReportGrid">
                  <div className="grid-item">
                    <span>Controller</span>
                    <span>{ReportData?.ReportData?.Controller}</span>
                  </div>
                  <div className="grid-item">
                    <span>KVA required @ 52 Hz</span>
                    <span>{ReportData?.ReportData?.Surface_KVARequired} kVA</span>
                  </div>
                  <div className="grid-item">
                    <span>Required surface voltage</span>
                    <span>{ReportData?.ReportData?.Surface_SurfaceVoltage} {ReportData?.ReportData?.Surface_SurfaceVoltage_Unit}</span>
                  </div>
                  <div className="grid-item">
                    <span>Power factor</span>
                    <span>{ReportData?.ReportData?.Surface_PowerFactor}</span>
                  </div>
                  <div className="grid-item">
                    <span>Basic electric cost / 24 Hr</span>
                    <span>{ReportData?.ReportData?.Surface_ElectricalCost} $</span>
                  </div>
                  <div className="grid-item">
                    <span>KW required @ 52 Hz</span>
                    <span>{ReportData?.ReportData?.Surface_KWRequired} {ReportData?.ReportData?.Surface_KWRequired_Unit}</span>
                  </div>

                  <div className="grid-item">
                    <span>Drive Amps @ 52 Hz</span>
                    <span>{ReportData?.ReportData?.Surface_DriveAmps} {ReportData?.ReportData?.Surface_DriveAmps_Unit}</span>
                  </div>

                  <div className="grid-item">
                    <span>Percentage of controller load</span>
                    <span>{ReportData?.ReportData?.Surface_PercentageControllerLoad + ' %'}</span>
                  </div>
                  <div className="grid-item">
                    <span>Controller type</span>
                    <span>{ReportData?.ReportData?.Surface_ControllerType}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EquipmentDetails;
